import React from 'react';

import {ViewView} from './View.styles';
import {useView} from './hooks';

import type {ViewProps} from './_types';

/**
 * # View
 *
 * A theme-aware component used to create layouts rapidly.
 *
 * ## Usage
 *
 * ```jsx
 * import {View} from '@packages/systems/spring';
 *
 * const Example = () => (
 *  <View
 *    border="$border1"
 *    backgroundColor="$blueTransparent"
 *    padding="$3 $2"
 *    _hover={{backgroundColor: '$blueTransparentHover'}}
 *    _before={{
 *      content: `""`,
 *      border: '$orangeBackground',
 *      marginRight: '$2',
 *    }}
 *  >
 *    Your content here
 *  </View>
 *);
 * ```
 *
 * @component
 */
export const View = React.forwardRef<HTMLDivElement, ViewProps>(
  (incomingProps: ViewProps, ref) => {
    const props = useView(incomingProps);

    return <ViewView {...props} ref={ref} />;
  }
);

View.displayName = 'View';
View.toString = ViewView.toString;

export default View;
